export default __webpack_public_path__ + "static/media/1.66f456c6.png";